import { DateTime } from "luxon";
import { useEffect, useState } from "react";

const useLuxonTimer = (undoDate?: DateTime) => {
  const [isTimerRunning, setIsTimerRunning] = useState<boolean>(false);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined = undefined;
    const undoDuration =
      undoDate && DateTime.isDateTime(undoDate)
        ? DateTime.now().until(undoDate).toDuration().milliseconds
        : NaN;
    if (!isNaN(undoDuration)) {
      setIsTimerRunning(true);
      timer = setTimeout(() => {
        setIsTimerRunning(false);
      }, undoDuration);
    }

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return { isTimerRunning, setIsTimerRunning };
};

export default useLuxonTimer;
